import { CHECKOUT_RATES_ACTIONS } from './checkoutRates.types'

/**
 *
 * @param {import('./checkoutRates.types').CheckoutRatesSlice['status']} payload
 * @returns {import('./checkoutRates.types').CheckoutRatesStatusAction}
 */
export const setCheckoutRatesStatusAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_STATUS,
  payload
})

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./checkoutRates.types').CheckoutRatesErrorsAction}
 */
export const setCheckoutRatesErrorsAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_ERRORS,
  payload
})

/**
 *
 * @param {import('./checkoutRates.types').ShippingRate[]} payload
 * @returns {import('./checkoutRates.types').CheckoutRatesRatesAction}
 */
export const setCheckoutRatesRatesAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_RATES,
  payload
})

/**
 * @param {import('./checkoutRates.types').ShippingRate} payload
 * @returns {import('./checkoutRates.types').CheckoutRatesSelectedRateAction}
 */
export const setCheckoutRatesSelectedRateAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_SELECTED_RATE,
  payload
})

/**
 * @returns {import('./checkoutRates.types').CheckoutRatesClearAction}
 */
export const clearCheckoutRatesErrorsAction = () => ({ type: CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_ERRORS })

/**
 * @returns {import('./checkoutRates.types').CheckoutRatesClearAction}
 */
export const clearCheckoutRatesRatesAction = () => ({ type: CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_RATES })

/**
 * @returns {import('./checkoutRates.types').CheckoutRatesClearAction}
 */
export const clearCheckoutRatesSelectedRateAction = () => ({
  type: CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_SELECTED_RATE
})

/**
 * Set selected rate for a specific shipping group
 * @param {string} groupId - The carrier_service_group_id
 * @param {{service_code: string, cost_in_cents: number, encrypted_cost: string, carrier_service_id: number, cart_item_ids: number[], customer_address_id: number}} rate - The selected rate object
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setSelectedRateForGroupAction = (groupId, rate) => ({
  type: CHECKOUT_RATES_ACTIONS.SET_SELECTED_RATE_FOR_GROUP,
  payload: { groupId, rate }
})

/**
 * Set calculation ID for async rate calculation
 * @param {string|null} payload - The calculation ID
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setCalculationIdAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CALCULATION_ID,
  payload
})

/**
 * Set shipping rate log ID
 * @param {string|null} payload - The shipping rate log ID
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setShippingRateLogIdAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_SHIPPING_RATE_LOG_ID,
  payload
})

/**
 * Set whether rates are currently being calculated
 * @param {boolean} payload - Is calculating flag
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setIsCalculatingAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_IS_CALCULATING,
  payload
})

/**
 * Set calculation progress
 * @param {import('./checkoutRates.types').CalculationProgress|null} payload - Progress data
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setCalculationProgressAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CALCULATION_PROGRESS,
  payload
})

/**
 * Set configuration ID for shipping group configuration
 * @param {string|null} payload - The configuration ID
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setConfigurationIdAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_CONFIGURATION_ID,
  payload
})

/** * Set shipping payment method (standard or third_party_billing)
 * @param {'standard' | 'third_party_billing'} payload - The shipping payment method
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setShippingPaymentMethodAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_SHIPPING_PAYMENT_METHOD,
  payload
})

/**
 * Set third party billing data
 * @param {import('./checkoutRates.types').ThirdPartyBillingData} payload - Third party billing form data
 * @returns {import('./checkoutRates.types').CheckoutRatesAction}
 */
export const setThirdPartyBillingDataAction = payload => ({
  type: CHECKOUT_RATES_ACTIONS.SET_THIRD_PARTY_BILLING_DATA,
  payload
})
